export default __webpack_public_path__ + "static/media/MMP_BB_Cancer Guide_2025.7c1ba815.pdf";